module.exports = __webpack_public_path__ + "static/media/info--handshake.0ac27b92.svg";